export const getPageTitle = (pathname: string) => {
  const path = pathname.split("/").filter((item) => item);
  const title = path[0].charAt(0).toLowerCase() + path[0].slice(1);

  return title === "parcels" ? "your_workspace" : title.split("-").join("_");
};
